import PropTypes from 'prop-types';
import DatePickerDropdown from 'components/calendar/date-picker-dropdown';

const DateInput = ({ onChange, onBlur, name, value, required = false, field, meta, helpers, triggerClassName }) => {
  return (
    <DatePickerDropdown
      triggerClassName="ignore-margin"
      date={value}
      onDayClick={(timestamp) => {
        onChange({ target: { name, value: timestamp } });
      }}
      onBlur={() => {
        onBlur({ target: { name } });
      }}
    />
  );
};

DateInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.number,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
  triggerClassName: PropTypes.string,
};

export default DateInput;
